<template>
    <button class="back-button" @click="router.go(-1)">
        <SvgIcon name="back" class="back-button__icon" />
        <span>{{ $t('button.back') }}</span>
    </button>
</template>

<script>
export default {
    name: 'BackButton',
};
</script>

<script setup>
import { useRouter } from 'vue-router';
import SvgIcon from '@/components/ui/SvgIcon';

const router = useRouter();
</script>

<style src='./styles.scss' lang='scss' scoped />
